import { create } from "zustand"
import { devLog } from "../utils/devLogger"
import toastError from "../errors/toastError"
import { useUsuarioStore } from "./usuarioStore"

let oPromessaUsuariosPermitidos = null
let mUsuariosPermitidosCache = null

const useUsuariosPermitidosStore = create((set, get) => ({
  // Estado inicial
  oUsuariosPermitidos: [],
  loading: false,
  error: null,

  // Ações
  loadUsers: async (userId, profile) => {
    const logger = devLog.create("usuariosPermitidosStore")

    if (mUsuariosPermitidosCache) {
      set({ oUsuariosPermitidos: mUsuariosPermitidosCache, loading: false })
      return mUsuariosPermitidosCache
    }

    if (oPromessaUsuariosPermitidos) {
      return oPromessaUsuariosPermitidos
    }

    oPromessaUsuariosPermitidos = (async () => {
      try {
        set({ loading: true, error: null })

        logger.debug("Iniciando carregamento de usuários permitidos")

        const mLista = await useUsuarioStore.getState().listaSimplesObter({
          validarPermissaoPerfil: true,
          companyId: localStorage.getItem("companyId"),
        })

        if (mLista && mLista.length > 0) {
          const usuariosPermitidos = mLista.map((u) => u.id)
          logger.debug({ usuariosPermitidos }, "Usuários permitidos carregados com sucesso")
          mUsuariosPermitidosCache = usuariosPermitidos
          set({ oUsuariosPermitidos: usuariosPermitidos, loading: false })
          return usuariosPermitidos
        }

        logger.warn("Nenhum usuário retornado pela API, usando apenas o usuário atual")
        mUsuariosPermitidosCache = [userId]
        set({ oUsuariosPermitidos: [userId], loading: false })
        return [userId]
      } catch (err) {
        logger.error({ error: err }, "Erro ao carregar usuários permitidos")
        toastError(err)
        mUsuariosPermitidosCache = [userId]
        set({ oUsuariosPermitidos: [userId], loading: false, error: err })
        return [userId]
      } finally {
        oPromessaUsuariosPermitidos = null
      }
    })()

    return oPromessaUsuariosPermitidos
  },

  // Verifica se um usuário específico está na lista de permitidos
  isUserPermitted: (userId) => {
    const { oUsuariosPermitidos } = get()
    return oUsuariosPermitidos.includes(userId)
  },

  // Adiciona um usuário à lista de permitidos (se necessário)
  addPermittedUser: (userId) => {
    const { oUsuariosPermitidos } = get()
    if (!oUsuariosPermitidos.includes(userId)) {
      set({ oUsuariosPermitidos: [...oUsuariosPermitidos, userId] })
    }
  },

  // Remove um usuário da lista de permitidos (se necessário)
  removePermittedUser: (userId) => {
    const { oUsuariosPermitidos } = get()
    set({ oUsuariosPermitidos: oUsuariosPermitidos.filter((id) => id !== userId) })
  },

  // Reseta para o estado inicial
  reset: () => {
    mUsuariosPermitidosCache = null
    oPromessaUsuariosPermitidos = null
    set({ oUsuariosPermitidos: [], loading: false, error: null })
  },
}))

export default useUsuariosPermitidosStore
